import { firebaseDB } from "../firebase/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  setDoc,
  where,
  Unsubscribe,
} from "firebase/firestore";
import { UserBank } from "../../domain/types/banks/UserBank";
import { Bank, BankId } from "../../domain/types/banks/Bank";

export class FirestoreUserBankRepository {
  private userBanksCollection = collection(firebaseDB, "userBanks");

  async create(userBank: UserBank): Promise<void> {
    const userBankRef = doc(this.userBanksCollection, userBank.userBankId);
    console.debug("Creating userBank:", userBank);
    await setDoc(userBankRef, userBank);
  }

  async getBank(bankId: BankId): Promise<Bank> {
    const bankRef = doc(this.userBanksCollection, bankId);
    const documentSnapshot = await getDoc(bankRef);
    return documentSnapshot.data() as Bank;
  }

  async getUserBanksByAppUserId(appUserId: string): Promise<UserBank[]> {
    const q = query(
      this.userBanksCollection,
      where("appUserId", "==", appUserId),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => doc.data() as UserBank);
  }

  observeUserBanksByAppUserId(
    appUserId: string,
    onChanged: (banks: UserBank[]) => void,
    onError: (error: Error) => void,
  ): Unsubscribe {
    const q = query(
      this.userBanksCollection,
      where("appUserId", "==", appUserId),
    );

    return onSnapshot(
      q,
      (querySnapshot) => {
        const banks = querySnapshot.docs.map((doc) => doc.data() as UserBank);
        onChanged(banks);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
